import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { getCommonClassNameDefault } from '@skatteetaten/ds-core-utils';
import { Icon } from '@skatteetaten/ds-icons';
import './styles.css';


var styles = {
    "button": "TopBannerButton-module_button__IV82S",
    "iconWrapper": "TopBannerButton-module_iconWrapper__o-Don",
    "icon": "TopBannerButton-module_icon__7aagc",
    "buttonText": "TopBannerButton-module_buttonText__YOICe",
    "button_filled": "TopBannerButton-module_button_filled__iNOJ9",
    "button_outline": "TopBannerButton-module_button_outline__Lqkra"
};

const TopBannerButton = /*#__PURE__*/ forwardRef(({ id, className = getCommonClassNameDefault(), classNames, lang, 'data-testid': dataTestId, svgPath, title, variant, ariaExpanded, onClick, onKeyDown, onFocus, children }, ref)=>{
    const variantClassName = variant ? styles[`button_${variant}`] : '';
    const concatenatedClassName = `${styles.button} ${variantClassName} ${className} ${classNames?.container ?? ''}`.trim();
    return /*#__PURE__*/ jsxs("button", {
        ref: ref,
        id: id,
        className: concatenatedClassName,
        lang: lang,
        "data-testid": dataTestId,
        "aria-expanded": ariaExpanded,
        type: 'button',
        onFocus: onFocus,
        onClick: onClick,
        onKeyDown: onKeyDown,
        children: [
            svgPath && /*#__PURE__*/ jsxs(Fragment, {
                children: [
                    /*#__PURE__*/ jsx("span", {
                        className: styles.iconWrapper,
                        children: /*#__PURE__*/ jsx(Icon, {
                            svgPath: svgPath,
                            className: styles.icon,
                            title: title
                        })
                    }),
                    /*#__PURE__*/ jsx("span", {
                        className: `${styles.buttonText} ${classNames?.text ?? ''}`.trim(),
                        children: children
                    })
                ]
            }),
            !svgPath && children
        ]
    });
});
TopBannerButton.displayName = 'TopBannerButton';

export { TopBannerButton };
